export default __webpack_public_path__ + "static/media/reims-habitat.40ee3fe8.png";